import { useEffect, useState } from 'react';
import { Button, Drawer, message } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { getBulkMailDetails, sendBulkMail } from '../../services/dropdownApi';
import CommonMailComposer from './CommonMailComposer';
import { areValidEmails, parseEmails } from './mailUtils';

export default function MailPopup() {
  const navigate = useNavigate();
  const { state = {} } = useLocation();
  const {
    selectedIds = [], selectedRecords = [], recipients = [],
    subject: initialSubject = '', onSend, moduleName = '', popupAction = {},
  } = state;
  const jobId = selectedIds[0] ?? selectedRecords[0]?._id ?? selectedRecords[0]?.id;
  const [mail, setMail] = useState({
    to: recipients.join(', '), cc: '', bcc: '', subject: initialSubject,
    contents: '', showCc: false, showBcc: false,
  });
  const [detailsLoaded, setDetailsLoaded] = useState(!jobId);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!jobId) return;
    getBulkMailDetails(jobId)
      .then((data) => setMail((current) => ({
        ...current,
        subject: data.subject || current.subject,
        to: data.toMail?.length ? (Array.isArray(data.toMail) ? data.toMail.join(', ') : String(data.toMail)) : current.to,
        cc: data.ccMail?.length ? (Array.isArray(data.ccMail) ? data.ccMail.join(', ') : String(data.ccMail)) : current.cc,
        bcc: data.bccMail?.length ? (Array.isArray(data.bccMail) ? data.bccMail.join(', ') : String(data.bccMail)) : current.bcc,
        contents: data.contents || current.contents,
        showCc: current.showCc || !!data.ccMail?.length,
        showBcc: current.showBcc || !!data.bccMail?.length,
      })))
      .catch(() => {})
      .finally(() => setDetailsLoaded(true));
  }, [jobId]);

  const canSend = (parseEmails(mail.to).length + parseEmails(mail.cc).length + parseEmails(mail.bcc).length) > 0
    && areValidEmails(mail.to) && areValidEmails(mail.cc) && areValidEmails(mail.bcc) && mail.subject.trim();

  async function handleSend() {
    if (!canSend || sending) return;
    setSending(true);
    try {
      await sendBulkMail({ jobId, toMail: parseEmails(mail.to), ccMail: parseEmails(mail.cc), bccMail: parseEmails(mail.bcc), subject: mail.subject, contents: mail.contents });
      message.success('Mail sent successfully');
      if (typeof onSend === 'function') onSend({ ...mail, message: mail.contents, selectedIds });
      navigate(-1);
    } catch (error) {
      message.error(error?.message || 'Failed to send mail');
    } finally { setSending(false); }
  }

  return (
    <Drawer open placement="right" onClose={() => navigate(-1)} closable={false} rootClassName="mail-popup" width={620} maskClosable={false}
      footer={<div className="mail-popup__footer"><Button onClick={() => navigate(-1)}>Cancel</Button><Button type="primary" loading={sending} disabled={!canSend} onClick={handleSend}>Send</Button></div>}>
      <CommonMailComposer
        value={mail}
        onChange={setMail}
        moduleName={moduleName}
        defaultTemplateId={popupAction.defaultTemplateId ?? state.defaultTemplateId ?? ''}
        ready={detailsLoaded}
        contextRecords={selectedRecords}
      />
    </Drawer>
  );
}
